// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import React from 'react';
import { Modal, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import styles from './candidates.module.scss';

interface ConfirmCancelModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  candidateName: string;
  loading?: boolean;
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({
  open,
  onClose,
  onConfirm,
  candidateName,
  loading = false
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Cancel Interview Invitation</h2>
          <button className={styles.modalClose} onClick={onClose} disabled={loading}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.warningMessage}>
            <WarningIcon className={styles.warningIcon} />
            <p>
              Are you sure you want to cancel the interview invitation for <strong>{candidateName}</strong>?
            </p>
          </div>
          <p className={styles.confirmHint}>This action will revoke the candidate's access to the interview link.</p>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.btnSecondary} onClick={onClose} disabled={loading}>
            Keep Invite
          </button>
          <button className={styles.btnReject} onClick={onConfirm} disabled={loading}>
            {loading ? 'Cancelling...' : 'Cancel Invite'}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmCancelModal;
